import type { PaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    notSelected: Palette['primary'];
  }
  interface PaletteOptions {
    notSelected?: PaletteOptions['primary'];
  }
}

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#0A8CD7', // Ciano A2A
    light: '#4EBAFE',
    dark: '#013A68', // Regal Blue
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#013A68', // Regal Blue
    light: '#025B96',
    dark: '#00203D',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#0A8CD7',
    light: '#E6F3F9', // Polar
    dark: '#01579b',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
    contrastText: '#FFFFFF',
  },
  notSelected: {
    main: 'rgba(0, 0, 0, 0.08)',
    light: 'rgba(0, 0, 0, 0.26)',
    dark: 'rgba(0, 0, 0, 0.26)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  background: {
    paper: '#FFFFFF',
    default: '#F8FBFE', // Subtle blue tint
  },
  text: {
    primary: '#000306', // Blue Charcoal
    secondary: 'rgba(0, 3, 6, 0.6)',
    disabled: 'rgba(0, 3, 6, 0.38)',
  },
  divider: 'rgba(0, 3, 6, 0.12)',
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#0B9AEC', // Brighter cyan for dark mode
    light: '#E6F3F9',
    dark: '#0A8CD7',
    contrastText: '#000306',
  },
  secondary: {
    main: '#90caf9',
    light: '#e3f2fd',
    dark: '#42a5f5',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#ffa726',
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  info: {
    main: '#29b6f6',
    light: '#EBEBEB',
    dark: '#0288d1',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    main: '#66bb6a',
    light: '#81c784',
    dark: '#388e3c',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  notSelected: {
    main: '#0288d1',
    light: '#03a9f4',
    dark: '#01579b',
    contrastText: '#FFFFFF',
  },
  background: {
    paper: '#171C21',
    default: '#000306', // Blue Charcoal
  },
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  action: {
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};
